// src/i18n.ts
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-chained-backend'
import resourcesToBackend from 'i18next-resources-to-backend'

import en from './locales/en/translation.json'
import id from './locales/id/translation.json'
import { LOCAL_STORAGE_KEY_LANG } from '@/constants/localStorageKeys'

const modules = import.meta.glob('./locales/**/*.json')

i18n
  .use(initReactI18next)
  .use(Backend)
  .init({
    partialBundledLanguages: true,
    lng: window.localStorage.getItem(LOCAL_STORAGE_KEY_LANG) || 'en',
    debug: import.meta.env.DEV,
    backend: {
      backends: [
        resourcesToBackend((language: string, namespace: string) => {
          const key = `./locales/${language}/${namespace}.json`
          const loader = modules[key]
          if (!loader) throw new Error(`Missing translation: ${key}`)
          return loader()
        }),
      ],
    },
    resources: {
      en: { translation: en },
      id: { translation: id },
    },
    fallbackNS: 'translation', //fall back for global transation
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  })

export default i18n
